
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "preview", "errorContainer"];

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  previewAvatar(e) {
    const file = e.currentTarget.files[0];
    if (!file) return;

    if (!this.validateFile(file)) {
      e.currentTarget.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  validateFile(file) {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      this.showError('Please select a JPEG, PNG, or WebP image.');
      return false;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      this.showError('File size must be smaller than 10MB.');
      return false;
    }

    this.clearError();
    return true;
  }

  showError(message) {
    this.clearError();
    
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.textContent = message;
    }
  }

  clearError() {
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.textContent = '';
    }
  }
}
